import { useQuery } from '@apollo/client';
import { customersApi } from '../api';
import { formatCreditAppsToTableData } from '../lib';

export function useCreditAppsTabDataFetch(customerAccountId: string) {
  const { data: customerCreditAppsData, loading: isCustomeCreditAppsLoading } = useQuery(
    customersApi.getCustomerCreditApps,
    {
      variables: {
        customerAccountId,
      },
    }
  );

  return {
    isLoading: isCustomeCreditAppsLoading,
    creditAppsTableData: formatCreditAppsToTableData(customerCreditAppsData?.customer?.customerCreditApps?.list ?? []),
  };
}
